module.exports = __webpack_public_path__ + "images/emoji/children_crossing.eedd00f6986b63df31a5.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/children_crossing.png
// module id = Pvro
// module chunks = 2